<div class="card-body">
    <div class="det-details">
        <form [formGroup]="payment">
            <div class="ibox-title report_flexweb">
                <div>
                    <h5>Receipt Cancellation</h5>
                </div>
                <div>
                    <figure>
                        <img src="../../assets/image/Group 28269.svg" [mat-dialog-close]="true" />
                    </figure>
                </div>
            </div>
            <!-- <mat-divider></mat-divider> -->
            <hr class="line">
            <div class="box2">

                <div class="example-card" *ngIf="data">
                    <div class="box">
                        <div class="color_1">
                            <div class="campus_dtl">
                                <h3 class="course">Campus Name</h3>
                                <h3 class="name">{{data.campusName}}</h3>

                            </div>
                        </div>
                        <div class="campus_dtl">
                            <h3 class="course">User Name</h3>
                            <h3 class="name">{{data.userName}}</h3>
                        </div>
                        <div class="color_1">
                            <div class="campus_dtl">
                                <h3 class="course">Adm No</h3>
                                <h3 class="name">{{data.admNo }}</h3>
                            </div>
                        </div>

                        <div class="campus_dtl">
                            <h3 class="course">PrePrinted ReceiptNo</h3>
                            <h3 class="name">{{data.prePrintedReceiptNo}}</h3>
                        </div>

                        <div class="color_1">
                            <div class="campus_dtl">
                                <h3 class="course">PayMode</h3>
                                <h3 class="name">{{data.payMode}}</h3>
                            </div>
                        </div>

                    </div>
                </div>


            </div>
            <div class="box2">
                <div>
                    <div class="campus_dtl">
                        <h3 class="course" style="font-weight: bold;">Head Name</h3>
                        <h3 class="name1" style="font-weight: bold;">Amount</h3>
                    </div>
                    <div>
                        <div class="campus_dtl" *ngFor="let item of payamount">
                            <h3 class="course">{{item.headCode}}</h3>
                            <h3 class="name1">{{item.amount | million  }}</h3>
                        </div>
                        <div class="campus_dtl">
                            <h3 class="course" style="font-weight: bold;">Total</h3>
                            <h3 class="name1"  style="font-weight: bold;">{{ getTotalAmount() | million  }}</h3>
                        </div>

                    </div>

                </div>

                <div>
                    <label for="" class="cctv_label">Remarks(optional)</label>
                    <!-- <input type="textaera" class="form-control" id=""
                    placeholder="Any Other Reason(s)"
                    formControlName="anyOtherReasons"> -->
                    <textarea class="form-control" id="exampleFormControlTextarea1" rows="3"
                        formControlName="anyOtherReasons"></textarea>
                </div>
                <hr class="line">
                <div class="button">
                    <button class="approval" (click)="approval(data)">Approval</button>
                    <button class="rejected" (click)="reject(data)">Rejected</button>
                </div>

            </div>
        </form>
    </div>
